import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationZH from './locales/zh/translation.json';
import { STORAGE_KEYS } from '../components/storageService';

// 尝试从 localStorage 获取语言设置
const getStoredLanguage = (): string | null => {
  try {
    const storedLang = localStorage.getItem(STORAGE_KEYS.LANGUAGE);
    return storedLang ? JSON.parse(storedLang) : null;
  } catch (e) {
    console.error('Error loading language from localStorage:', e);
    return null;
  }
};

// 根据浏览器和userAgent自动检测用户语言
export const detectUserLanguage = (): string => {
  // 首先检查用户是否已经设置了语言偏好
  const storedLanguage = getStoredLanguage();
  if (storedLanguage) {
    return storedLanguage;
  }

  // 如果没有存储的语言设置，则从浏览器中检测
  try {
    // 检查 navigator.languages (一个按偏好排序的语言数组)
    if (typeof window !== 'undefined' && window.navigator) {
      // 首选语言列表
      const browserLanguages = window.navigator.languages || [];
      
      // 浏览器首选语言
      const browserLanguage = window.navigator.language || 
                             (window.navigator as any).userLanguage || 
                             (window.navigator as any).browserLanguage;
      
      // 检查是否有中文语言代码
      const hasChineseLanguage = [...browserLanguages, browserLanguage]
        .some(lang => /^zh\b/.test(lang));
      
      if (hasChineseLanguage) {
        return 'zh';
      }
    }
  } catch (error) {
    console.error('Error detecting browser language:', error);
  }

  // 默认返回英文
  return 'en';
};

const resources = {
  en: {
    translation: translationEN
  },
  zh: {
    translation: translationZH
  }
};

// 初始化语言设置
const initialLanguage = detectUserLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage, // 使用自动检测的语言
    fallbackLng: 'en', // 如果当前语言没有对应的翻译，则使用英文
    interpolation: {
      escapeValue: false // 不转义 HTML
    }
  });

export default i18n;